import React from 'react';

type IconProps = {
    width?: number;
    height?: number;
    color?: string;
};

const IconSettingSignout: React.FC<IconProps> = ({
    width = 20,
    height = 20,
    color = '#FF3589',
}) => {
    return (
        <svg
            width={height}
            height={width}
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clip-path="url(#clip0_11654_83609)">
                <path
                    d="M8.75 3.125H3.75V16.875H8.75"
                    stroke={color}
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M8.75 10H17.5"
                    stroke={color}
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M14.375 6.875L17.5 10L14.375 13.125"
                    stroke={color}
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_11654_83609">
                    <rect width="20" height="20" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default IconSettingSignout;
